export default "__VITE_ASSET__2f451042__"